import { read, utils, WorkBook } from "xlsx";

export const getBatchFields = async (file: File, domainData: any) => {
  try {
    const buffer = await file.arrayBuffer();
    const wb: WorkBook = read(buffer);

    // Find sheet with "Batch JE" in the name
    const batchJESheetName = wb.SheetNames.find((sheetName) => sheetName.toLocaleLowerCase().includes("batch je"));

    if (!batchJESheetName) {
      throw new Error("No sheet containing 'Batch JE' found in the workbook");
    }

    const ws = wb.Sheets[batchJESheetName];
    const headerFieldsArray: any[] = utils.sheet_to_json(ws, { header: 1, defval: "", range: "A3:H11" });
    const batchName = headerFieldsArray[1][1];
    const description = headerFieldsArray[2][1];
    const batchDescription = description.substring(0, 25);
    const purpose = headerFieldsArray[3][1];
    const batchPurpose = purpose.substring(0, 250);
    const reason = headerFieldsArray[0][3];
    const reasonCode = domainData.find((x) => x.jeReason === reason);
    const batchReasonCode: string = reasonCode ? reasonCode.code : "";
    return {
      batchName,
      batchDescription,
      batchPurpose,
      batchReasonCode
    };
  } catch (error) {
    throw new Error(
      "Error occurred during file processing :" + (error instanceof Error ? error.message : String(error))
    );
  }
};
